import type { Perm } from "../access/api";

/**
 * The one rule for the Routes pages in the new access model, the menu's own (shell/nav.ts): See routes plus a way to use them
 * (Plan routes, Change routes or Visits). Planners see what they planned or were given; the others what was given to them.
 * The server decides which routes are in the list and whether one route opens.
 */
export const routesOpen = (perms: readonly Perm[] | readonly string[]): boolean => {
  const can = (p: string) => (perms as readonly string[]).includes(p);
  return can("routes.read") && (can("routes.plan") || can("routes.change") || can("routes.follow"));
};
